import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';

@Component({
  selector: 'admin-customer-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: [ './invoices.component.scss' ]
})
export class AdminCustomerInvoicesComponent extends AbstractListComponent implements OnInit {

  @Input() customer: any = {};

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getResourceUrl(): string {
    return `/admin/payment/${this.customer.id}/invoices`;
  }
}
